import React from "react";
import tw from "tailwind-styled-components";
import { MdClose, MdPhone } from "react-icons/md";
import moment from "moment";
import { ActionSection, ScrollableContent, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";
import Config, { moveOutReasons } from "../../Config";

const ViewRequest = ({
    setIsViewReq,
    selectedData,
    setIsReqRej,
    setInitiateEviction,
    setIsReturnDeposit,
    setOnboardingRequestAccept,
    setIsReqAccept,
    setIsGuestReqAccept
}) => {
    const onClose = () => {
        setIsViewReq(false);
    };

    const handleAccept = () => {
        if (selectedData?.type === Config.REQUEST_TYPE.REFUND) {
            setIsReqAccept(true);
            setIsViewReq(false);
        } else if (selectedData?.type === Config.REQUEST_TYPE.MOVEOUT) {
            setInitiateEviction(true)
            setIsViewReq(false);
        } else if (selectedData?.type === Config.REQUEST_TYPE.GUEST) {
            setIsGuestReqAccept(true)
            setIsViewReq(true);
        }
        else {
            setOnboardingRequestAccept(true)
            setIsViewReq(false);
        }

    };

    const handleReject = () => {
        setIsReqRej(true);
        setIsViewReq(false);
    };

    const getMoveOutReasonLabel = (reasonValue) => {
        const reasonObj = moveOutReasons.find(reason => reason.value === reasonValue);
        return reasonObj ? reasonObj.label : reasonValue;
    };

    const formatDate = (dateString) => {
        return dateString ? moment(dateString).format("DD, MMM YY") : "Not set";
    };
    return (
        <Container>
            <Header>
                <Title>Request Details</Title>
                <button onClick={onClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>

            <ProfileSection className="flex justify-between">
                <UserInfo>
                    <span className="font-medium mb-0">{selectedData?.tenantName}</span>
                    <span className="text-sm text-gray-600">
                        #{selectedData?.tenantMobile}
                    </span>
                </UserInfo>
                {selectedData?.type === Config.REQUEST_TYPE.MOVEOUT &&
                    <div className="flex flex-col gap-0">
                        <span className="text-gray-500 text-sm">{"Dues"}</span>
                        <span
                            className={`text-xl font-semibold ${selectedData?.totalDues > 0 ? "text-red-600" : "text-gray-700"
                                }`}
                        >
                            {'₹' + selectedData?.totalDues}
                        </span>
                    </div>
                }
            </ProfileSection>

            <Content>
                <ScrollableContent>
                    <Wrapper>
                        <BtnWrapper>
                            <SectionTitle>Request Information</SectionTitle>
                        </BtnWrapper>

                        <Section>
                            {selectedData?.type === Config.REQUEST_TYPE.MOVEOUT &&
                                <>
                                    <Row>
                                        <FlexCol>
                                            <Label>MoveIn Date</Label>
                                            <Value>{formatDate(selectedData?.moveInDate)}</Value>
                                        </FlexCol>
                                        <FlexCol>
                                            <Label>MoveOut Date</Label>
                                            <Value>{formatDate(selectedData?.moveOutDate)}</Value>
                                        </FlexCol>
                                    </Row>
                                    <Row>
                                        <FlexCol>
                                            <Label>Notice Period</Label>
                                            <Value>{selectedData?.noticePeriod + " Month/s"}</Value>
                                        </FlexCol>
                                        <FlexCol>
                                            <Label>LockIn Period</Label>
                                            <Value>{selectedData?.lockInPeriod + " Month/s"}</Value>
                                        </FlexCol>
                                    </Row>
                                    <Row>
                                        <FlexCol>
                                            <Label>Property Name</Label>
                                            <Value>{selectedData?.propertyName}</Value>
                                        </FlexCol>
                                        <FlexCol>
                                            <Label>Request Date</Label>
                                            <Value>{formatDate(selectedData?.createdAt)}</Value>
                                        </FlexCol>
                                    </Row>
                                    <Row className="grid grid-cols-1">
                                        <FlexCol>
                                            <Label>Move Out Reason</Label>
                                            <Value>{getMoveOutReasonLabel(selectedData?.moveOutReason)}</Value>
                                        </FlexCol>
                                    </Row>
                                </>
                            }
                            {selectedData?.type == Config.REQUEST_TYPE.GUEST &&
                                <>
                                    <Row>
                                        <FlexCol>
                                            <Label>Guest Name</Label>
                                            <Value>{selectedData?.guestName}</Value>
                                        </FlexCol>
                                        <FlexCol>
                                            <Label>Guest Mobile</Label>
                                            <Value>{selectedData?.guestMobile}</Value>
                                        </FlexCol>
                                    </Row>
                                    <Row>
                                        <FlexCol>
                                            <Label>Relation</Label>
                                            <Value>{selectedData?.relation}</Value>
                                        </FlexCol>
                                        <FlexCol>
                                            <Label>No. Of Guests</Label>
                                            <Value>{selectedData?.noOfGuests}</Value>
                                        </FlexCol>
                                    </Row>
                                    <Row>
                                        <FlexCol>
                                            <Label>Stay Period</Label>
                                            <Value>
                                                {formatDate(selectedData?.checkInDate)} - {formatDate(selectedData?.checkOutDate)}
                                            </Value>
                                        </FlexCol>
                                        <FlexCol>
                                            <Label>Request Date</Label>
                                            <Value>{formatDate(selectedData?.createdAt)}</Value>
                                        </FlexCol>
                                    </Row>

                                    <Row className="grid grid-cols-1">
                                        <FlexCol>
                                            <Label>Reason</Label>
                                            <Value>{selectedData?.reason}</Value>
                                        </FlexCol>
                                    </Row>
                                </>
                            }
                            <Row className="grid grid-cols-1">
                                <FlexCol>
                                    <Label>Description</Label>
                                    <Value>{selectedData?.description}</Value>
                                </FlexCol>
                            </Row>
                        </Section>



                    </Wrapper>
                </ScrollableContent>
                <ActionSection>
                    <SideCancelBtn onClick={handleReject}>
                        Reject
                    </SideCancelBtn>

                    <SubmitBtn onClick={handleAccept}
                    >
                        Accept
                    </SubmitBtn>
                </ActionSection>
            </Content>
        </Container>
    );
};

// Styled Components
const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
const Section = tw.div`border border-gray-200 p-4 rounded-lg mb-3`;
const SectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center`;
const Row = tw.div`grid grid-cols-2 gap-4 py-1 md:p-1`;
const Label = tw.label`text-sm text-gray-400 font-normal`;
const Value = tw.span`text-gray-600 text-md`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;
const ActionWrapper = tw.div`flex gap-4 justify-end `;
const AcceptButton = tw.button`
    px-6 py-2 bg-green-500 text-white rounded-lg 
    hover:bg-green-600 transition-colors duration-200 
    font-medium text-sm
    disabled:opacity-50 disabled:cursor-not-allowed
`;
const RejectButton = tw.button`
    px-6 py-2 bg-red-500 text-white rounded-lg 
    hover:bg-red-600 transition-colors duration-200 
    font-medium text-sm
    disabled:opacity-50 disabled:cursor-not-allowed
`;

export default ViewRequest;